import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="bg-ocean-950 text-sand-50/70 py-16 border-t border-white/10 text-xs" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <h3 className="font-display text-xl text-white font-bold mb-2">Raffiel Nias</h3>
        <p className="text-xs text-sand-50/60 max-w-sm mb-4">
          Beachfront surf hotel, pool, rooftop café, and board transport in
          Sorake Beach, Lagundri Bay, South Nias.
        </p>
        <p className="font-mono-clean text-[11px] text-sand-50/40">
          From $45/night · Monthly stays from $700
        </p>
      </div>
      <div>
        <h4 className="font-mono-clean uppercase tracking-wider text-white text-xs mb-4">Explore</h4>
        <ul className="space-y-2">
          <li><Link to="/rooms" className="hover:text-white transition-colors">Rooms & Suites</Link></li>
          <li><Link to="/board-transfer" className="hover:text-white transition-colors">Board Cargo Medan/Padang</Link></li>
          <li><Link to="/surf-lessons" className="hover:text-white transition-colors">Lessons & Photography</Link></li>
          <li><Link to="/#hotel-facilities" className="hover:text-white transition-colors">Facilities & Mini Gym</Link></li>
          <li><Link to="/#dining" className="hover:text-white transition-colors">Rooftop Café</Link></li>
          <li><Link to="/guide" className="hover:text-white transition-colors">Sorake & Lagundri Guide</Link></li>
          <li><Link to="/blog" className="hover:text-white transition-colors">Surf Guide & Blog</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-mono-clean uppercase tracking-wider text-white text-xs mb-4">Location</h4>
        <p className="text-xs leading-relaxed text-sand-50/60 mb-3">
          Sorake Beach, Lagundri Bay<br />
          South Nias, North Sumatra<br />
          Indonesia
        </p>
        <Link to="/#contact" className="inline-block text-white font-semibold underline underline-offset-4">
          Get in touch &rarr;
        </Link>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-6 mt-12 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4 text-[11px] text-sand-50/40">
      <p>Raffiel Nias Hotel · Sorake Beach</p>
      <p>Direct bookings powered by GuestPro & WhatsApp</p>
    </div>
  </footer>
);

export default Footer;
